<template>
  <div>
      <div class="col-md-12">
        <boton-atras :nombre_ruta="'Menu'"/>
      </div>
      <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Presupuesto de Egresos por Organismo Público</h1>
      </div>
      <div>
        <div class="col-12 mt-2 mb-5" v-if="dataListado">
          <px-select idSelect="anio_pe" placeholder="Seleccione año a consultar" :options="dataListado" @KuramaSelect="opcSelected = $event"></px-select>
        </div>
        <div class="w-100 mt-3" v-if="data">
          <h5>{{titulo}}</h5>
          <tabla-simple id="tablaPEOP" :datos="data" :titulo="this.data.text" />
        </div>
        <span v-html="fecha_actualizacion"></span>
      </div>
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import RendicionDeCuentas from "@/services/rendicionDeCuentas/rendicionDeCuentas.js";
const _serviciosRendicionC = new RendicionDeCuentas();
import botonAtras from '../../button-atras.vue';
import tablaSimple from '@/components/tablaSimple.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  mixins: [DateFormat],
  components: {botonAtras, tablaSimple},
  created(){
    window.scrollTo(0, 0);
    this.getPresupuestoEgresosOP()
  },
  data(){
    return{
      dataPresupEgreOp: [],
      dataListado: [],
      opcSelected: null,
      data: [],
      titulo: '',
      fecha_actualizacion: '',
    }
  },
  methods:{
    async getPresupuestoEgresosOP() {
      try {
          const response = await _serviciosRendicionC.getPresupuestoEgresosOP(mapFun.presupuestoEgresosOP);
          this.dataPresupEgreOp = response.data;
          this.dataListado = this.dataPresupEgreOp.map(function (mapeoSelect) {
              return {
                id: mapeoSelect.id,
                value: mapeoSelect.id,
                fecha_actualizacion: mapeoSelect.fecha_actualizacion,
                text: mapeoSelect.titulo,
              };
          });
      } catch (error) {
          console.log('error', error.message);
      }
    },
    getContenidoByOpc(){
        this.data = this.dataPresupEgreOp.filter(itemsec => itemsec.id == this.opcSelected.id);
        this.titulo = this.data[0].titulo;
        this.data.forEach(element => {
              this.data = element.secciones.map(function (mapeoSelect) {
                return {
                  id: mapeoSelect.id_seccion,
                  text: mapeoSelect.titulo_seccion,
                  seccion: mapeoSelect.archivos_seccion,
                };
              });
        });
        this.data = this.data[0];
    }
  },
  watch: {
    opcSelected(){
      if(this.opcSelected){this.getContenidoByOpc(); this.fecha_actualizacion = this.DateFormatText(this.opcSelected.fecha_actualizacion);}
    }
  },
}
</script>